import { useEffect, useState } from "react";
import { Trophy, Crown } from "lucide-react";
import { api } from "@/lib/api";

export function Leaderboard({ meId, base = "/playzone/balloon", title = "Balloon Pop leaderboard", unit = "" }) {
  const [period, setPeriod] = useState("all");
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); api.get(`${base}/leaderboard`, { params: { period } }).then((r) => setData(r.data)).catch(() => setData({ entries: [] })); }, [period, base]);
  const tab = (k, label) => (
    <button onClick={() => setPeriod(k)} data-testid={`pz-lb-tab-${k}`}
      className={`px-4 py-1.5 rounded-full text-xs font-bold transition-colors ${period === k ? "bg-white text-black" : "text-white/60 hover:text-white"}`}>{label}</button>
  );
  return (
    <section id="leaderboard" className="pz-panel" data-testid="pz-leaderboard">
      <div className="flex items-center gap-3 mb-4 flex-wrap">
        <Trophy className="w-5 h-5 text-[#FFB800]" />
        <h2 className="text-base md:text-lg font-black flex-1">{title}</h2>
        <div className="flex bg-white/5 rounded-full p-1">{tab("all", "All-time")}{tab("week", "This week")}</div>
      </div>
      {period === "week" && data?.resets_at && <p className="text-[11px] text-white/50 -mt-2 mb-3">Resets every Monday · {data.week}</p>}
      {!data ? <div className="space-y-2">{[0, 1, 2, 3].map((i) => <div key={i} className="h-11 rounded-xl bg-white/5 animate-pulse" />)}</div>
        : !data.entries.length ? <p className="text-sm text-white/50 py-6 text-center" data-testid="pz-lb-empty">No scores yet — be the first on the board.</p>
        : <ol className="space-y-1.5">{data.entries.map((e) => (
          <li key={e.user_id} data-testid={`pz-lb-row-${e.rank}`}
            className={`flex items-center gap-3 px-3 py-2 rounded-xl ${e.user_id === meId ? "bg-[#00E5FF]/10 ring-1 ring-[#00E5FF]/40" : "bg-white/[0.03]"}`}>
            <span className={`w-7 text-center font-black ${e.rank === 1 ? "text-[#FFB800]" : e.rank <= 3 ? "text-white" : "text-white/40"}`}>{e.rank === 1 ? <Crown className="w-4 h-4 mx-auto" /> : e.rank}</span>
            <span className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-black text-black" style={{ background: e.avatar_color || "#00E5FF" }}>{(e.name || "?")[0].toUpperCase()}</span>
            <span className="flex-1 truncate text-sm font-semibold">{e.name}{e.user_id === meId ? " (you)" : ""}</span>
            <span className="font-black tabular-nums">{e.score.toLocaleString()}{unit}</span>
          </li>
        ))}</ol>}
    </section>
  );
}
